import * as dm from '../../../../data-models';
import PersonAtLaptop from '../../../../images/person-at-laptop.svg';

type Props = {
  claim: dm.ClaimInProcess;
  keyId: number;
};

const TemporaryClaimCard = ({ claim, keyId }: Props) => {
  return (
    <div
      id={`temporary-claim-card-${keyId}`}
      className="tw-px-6 tw-py-8 tw-mb-8 tw-border-solid tw-border-l-[16px] tw-border-t-0 tw-border-b-0 tw-border-r-0 tw-border-unm-interactive01-400 tw-bg-white tw-rounded-lg tw-shadow-[0_3px_6px_rgba(46,46,46,0.16)]"
    >
      {/* Mobile View */}
      <div className="tw-flex tw-flex-col md:tw-hidden tw-border-t tw-gap-4">
        <img
          src={PersonAtLaptop}
          alt="Person at laptop"
          className="tw-w-36 tw-self-center"
        />
        <div>
          <div className="tw-text-[28px] tw-text-unm-primary02-400 tw-leading-9 tw-mb-4">
            We're working on your request
          </div>
          <div className="tw-text-neutral-600 tw-m-0 tw-grow tw-font-normal tw-text-base tw-leading-6">
            Your request for <b>{claim.reason || 'Claim Submission'}</b> was
            successfully submitted.
            <br />
            <br />
            We'll update this page automatically when your request is available
            to view.
            <br />
          </div>
        </div>
      </div>

      {/* Desktop View */}
      <div className="tw-hidden md:tw-flex tw-border-t tw-flex-row tw-gap-4 tw-items-center">
        <img src={PersonAtLaptop} alt="Person at laptop" className="tw-py-4" />
        <div className="tw-flex tw-flex-col">
          <div className="tw-text-2xl md:tw-text-[28px] tw-text-unm-primary02-400 tw-leading-9 tw-mb-4">
            We're working on your request
          </div>
          <div className="tw-text-neutral-600 tw-m-0 tw-grow tw-font-normal tw-text-sm md:tw-text-base tw-leading-6">
            Your request for <b>{claim.reason || 'Claim Submission'}</b> was
            successfully submitted. We'll update this page automatically when
            your request is available to view.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemporaryClaimCard;
